<template>
  <!-- eslint-disable max-len -->
  <div class="form__group">
    <div class="form__group-item no-vertical-spacing">
      <div class="heading-bar-sm"></div>
      <button
        id="accordion-control-language"
        class="accordion__button"
        aria-controls="accordion-control-language"
        :aria-expanded="(!!languagesAccordionOpen).toString()"
        @click="accordionToggle"
      >
        <label class="form__label" for="form-languages">Language</label>
        <svg
          id="accordion-svg"
          width="16px"
          height="16px"
          viewBox="0 0 24 24"
          :class="(!!languagesAccordionOpen ? 'accordion__dropdown--open ' : '') + 'accordion__dropdown'"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
        >
          <title>icon_caret</title>
          <g id="Production---Display-Languages" stroke="#FF0066" stroke-width="1" fill="none" fill-rule="evenodd">
            <g transform="translate(-1281.000000, -1626.000000)" fill-rule="nonzero">
              <g transform="translate(976.000000, 1568.000000)">
                <g transform="translate(305.000000, 58.000000)">
                  <g>
                    <path
                      d="M17.4571068,2.54289322 C17.8476311,2.93341751 17.8476311,3.56658249 17.4571068,3.95710678 L8.665,12.75 L17.4571068,21.5428932 C17.8476311,21.9334175 17.8476311,22.5665825 17.4571068,22.9571068 C17.0665825,23.3476311 16.4334175,23.3476311 16.0428932,22.9571068 L6.54289322,13.4571068 C6.15236893,13.0665825 6.15236893,12.4334175 6.54289322,12.0428932 L16.0428932,2.54289322 C16.4334175,2.15236893 17.0665825,2.15236893 17.4571068,2.54289322 Z"
                      fill="#0086CC"
                      transform="translate(12.000000, 12.750000) rotate(-90.000000) translate(-12.000000, -12.750000) "
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </svg>
      </button>
    </div>
    <div
      id="control-top-languages"
      :class="
        (!!languagesAccordionOpen ? 'accordion__answer--open ' : '') + 'form__group-item accordion__answer no-vertical-spacing'
      "
      :aria-hidden="(!languagesAccordionOpen).toString()"
    >
      <div v-for="(language, displayText) in topLanguages" :key="language">
        <input
          :id="'form-languages-' + language"
          v-model="languages"
          name="language"
          :value="language"
          type="checkbox"
          class="form__checkbox"
          @change="updateLanguages()"
        />
        <label class="form__checkbox-label sm-vertical-spacing" :for="'form-languages-' + language">{{ displayText }}</label>
      </div>
    </div>
    <div
      id="more-languages-title"
      :class="
        (!!languagesAccordionOpen && !!showMoreLanguagesOpen ? 'accordion__answer--open ' : '') +
        'form__group-item accordion__answer sm-vertical-spacing md-vertical-spacing-top accordion__show-more-title'
      "
      :aria-hidden="(!(!!languagesAccordionOpen && !!showMoreLanguagesOpen)).toString()"
    >
      More Languages
    </div>
    <div
      id="control-all-languages"
      :class="
        (!!languagesAccordionOpen && !!showMoreLanguagesOpen ? 'accordion__answer--open ' : '') +
        'form__group-item accordion__answer md-vertical-spacing'
      "
      :aria-hidden="(!(!!languagesAccordionOpen && !!showMoreLanguagesOpen)).toString()"
    >
      <div v-for="(language, displayText) in allLanguages" :key="language">
        <input
          :id="'form-languages-' + language"
          v-model="languages"
          name="language"
          :value="language"
          type="checkbox"
          class="form__checkbox"
          @change="updateLanguages()"
        />
        <label class="form__checkbox-label sm-vertical-spacing" :for="'form-languages-' + language">{{ displayText }}</label>
      </div>
    </div>
    <div
      id="show-more-languages"
      :class="
        (!!languagesAccordionOpen && !showMoreLanguagesOpen ? 'accordion__answer--open ' : '') +
        'form__group-item accordion__answer no-vertical-spacing'
      "
      :aria-hidden="showMoreButtonHidden.toString()"
    >
      <button
        id="show-more-button"
        class="link--primary search__old-link"
        aria-controls="accordion-control-language"
        style="font-size: 16px"
        @click="showMoreLanguages"
      >
        More Languages
        <g id="Production---Display-Show-More-Languages" stroke="#FF0066" stroke-width="1" fill="none" fill-rule="evenodd" />
      </button>
    </div>
  </div>
  <!-- eslint-enable max-len -->
</template>

<script lang="ts">
export default {
  name: 'LanguageDropdown',
  props: ['inputLanguages'],
  data(): any {
    return {
      languages: this.inputLanguages,
      languagesAccordionOpen: false,
      showMoreLanguagesOpen: false,
      showMoreButtonHidden: true,
    };
  },
  computed: {
    topLanguages(): Object {
      return {
        'American Sign Language': 'AMERICAN_SIGN_LANGUAGE',
        Arabic: 'ARABIC',
        'Chinese (Cantonese)': 'CHINESE_CANTONESE',
        'Chinese (Mandarin)': 'CHINESE_MANDARIN',
        'Chinese (Other Dialects)': 'CHINESE_OTHER_DIALECTS',
        French: 'FRENCH',
        German: 'GERMAN',
        'Haitian Creole': 'HAITIAN_CREOLE',
        Hindi: 'HINDI',
        Italian: 'ITALIAN',
        Japanese: 'JAPANESE',
        Korean: 'KOREAN',
        Polish: 'POLISH',
        Portuguese: 'PORTUGUESE',
        Russian: 'RUSSIAN',
        Spanish: 'SPANISH',
      };
    },
    allLanguages(): Object {
      return {
        Armenian: 'ARMENIAN',
        Bengali: 'BENGALI',
        Bulgarian: 'BULGARIAN',
        Burmese: 'BURMESE',
        Czech: 'CZECH',
        Danish: 'DANISH',
        Dutch: 'DUTCH',
        Esperanto: 'ESPERANTO',
        Estonian: 'ESTONIAN',
        Fante: 'FANTE',
        Farsi: 'FARSI',
        Finnish: 'FINNISH',
        Greek: 'GREEK',
        Hausa: 'HAUSA',
        Hawaiian: 'HAWAIIAN',
        Hebrew: 'HEBREW',
        Hungarian: 'HUNGARIAN',
        Igbo: 'IGBO',
        Irish: 'IRISH',
        Norwegian: 'NORWEGIAN',
        Punjabi: 'PUNJABI',
        Sinhala: 'SINHALA',
        Swahili: 'SWAHILI',
        Swedish: 'SWEDISH',
        Teme: 'TEME',
        Thai: 'THAI',
        Tigre: 'TIGRE',
        Tigrinya: 'TIGRINYA',
        Turkish: 'TURKISH',
        Twi: 'TWI',
        Ukrainian: 'UKRAINIAN',
        Urdu: 'URDU',
        Welsh: 'WELSH',
        Yiddish: 'YIDDISH',
      };
    },
  },
  watch: {
    inputLanguages(newVal) {
      this.languages = newVal;
      if (newVal && newVal.length > 0) {
        const input = newVal.toString().split(',');
        this.checkLanguages(this.topLanguages, input, 0);
        this.checkLanguages(this.allLanguages, input, 1);
      }
    },
  },
  mounted() {
    if (this.inputLanguages.length > 0) {
      const input = this.inputLanguages.toString().split(',');
      this.checkLanguages(this.topLanguages, input, 0);
      this.checkLanguages(this.allLanguages, input, 1);
    }
  },
  methods: {
    accordionToggle(event) {
      event.preventDefault();
      this.languagesAccordionOpen = !this.languagesAccordionOpen;
      this.showMoreButtonHidden = !this.languagesAccordionOpen;
      this.showMoreLanguagesOpen = false;
    },
    showMoreLanguages(event) {
      event.preventDefault();
      this.showMoreButtonHidden = true;
      this.showMoreLanguagesOpen = true;
    },
    updateLanguages() {
      this.$emit('updateLanguages', this.languages);
    },
    setTopLanguagesOpen() {
      this.languagesAccordionOpen = true;
      this.showMoreButtonHidden = false;
      this.showMoreLanguagesOpen = false;
    },
    setAllLanguagesOpen() {
      this.languagesAccordionOpen = true;
      this.showMoreButtonHidden = true;
      this.showMoreLanguagesOpen = true;
    },
    checkLanguages(list, input, func) {
      Object.keys(list).forEach((key) => {
        Object.keys(input).forEach((inputKey) => {
          if (list[key] === input[inputKey]) {
            if (func === 0) {
              this.setTopLanguagesOpen();
            } else {
              this.setAllLanguagesOpen();
            }
          }
        });
      });
    },
  },
};
</script>
